import React from "react";
import {
  CTable,
  CTableHead,
  CTableBody,
  CTableRow,
  CTableHeaderCell,
  CTableDataCell,
} from "@coreui/react";

const XemLichLamViec = ({ schedule }) => {
  if (!schedule) {
    return <p className="text-danger">Chưa có lịch nào được lưu!</p>;
  }

  return (
    <div>
      <h4 className="mb-3">Xem lịch làm việc</h4>
      <CTable bordered responsive>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell className="bg-light text-center">
              Ca làm
            </CTableHeaderCell>
            {Object.keys(schedule).map((day, index) => (
              <CTableHeaderCell
                key={index}
                className="text-center text-primary"
              >
                {day}
              </CTableHeaderCell>
            ))}
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {["Sáng", "Chiều", "Tối"].map((shift, index) => (
            <CTableRow key={index}>
              <CTableDataCell className="bg-warning text-center">
                {shift}
              </CTableDataCell>
              {Object.keys(schedule).map((day, idx) => (
                <CTableDataCell key={idx} className="text-center">
                  {schedule[day][shift] || "—"}
                </CTableDataCell>
              ))}
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>
    </div>
  );
};

export default XemLichLamViec;
